import { useQuery } from "@tanstack/react-query";
import api from "../api";

const useGetActorSummary = (actorName: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["getActorSummary", actorName],
    queryFn: () => api.getActorSummary(actorName),
    select: ({ data: responseData }) => responseData,
    enabled: !!actorName
  });

  return { data, isLoading };
};

export default useGetActorSummary;
